import { ApolloError, gql, useMutation } from "@apollo/client";
import { EditBusinessInfoInput, EditBusinessInfoMutation, EditBusinessInfoMutationVariables } from "../generated/graphql";

export interface IEditBusinessInfoFormProps extends EditBusinessInfoInput {
}

const EDIT_BUSINESS_INFO_QUERY = gql`
  mutation editBusinessInfo($input: EditBusinessInfoInput!) {
    editBusinessInfo(input: $input) {
      ok
      err
    }
  }
`;

export const useEditBusinessInfo = (onCompleted?: (data: EditBusinessInfoMutation) => void, onError?: (error: ApolloError) => void) => {
  return useMutation<EditBusinessInfoMutation, EditBusinessInfoMutationVariables>(
    EDIT_BUSINESS_INFO_QUERY,
    {
      onCompleted,
      onError,
    }
  );
};